export interface LabeledTab {
  id: string;
  title?: string | null;
  disambiguator?: string | null;
}

/**
 * Return the disambiguator to render for each open tab whose title collides
 * with another open tab's title. Non-colliding tabs are omitted so labels stay
 * short unless two same-named charts are open at once.
 */
export function getCollidingTabDisambiguators(tabs: LabeledTab[]): Map<string, string> {
  const titleCounts = new Map<string, number>();
  for (const tab of tabs) {
    if (!tab.title) continue;
    titleCounts.set(tab.title, (titleCounts.get(tab.title) || 0) + 1);
  }
  const result = new Map<string, string>();
  for (const tab of tabs) {
    if (!tab.title || !tab.disambiguator) continue;
    if ((titleCounts.get(tab.title) || 0) > 1) result.set(tab.id, tab.disambiguator);
  }
  return result;
}

export function formatTabLabel(title: string, disambiguator?: string | null): string {
  return disambiguator ? `${title} · ${disambiguator}` : title;
}
